import { withTranslation } from 'react-i18next';

import AddUser from './AddUser';

export default withTranslation()(AddUser);
